import React, { useState, useEffect } from "react";
import "../../../assets/styles/pages/Relatorio/PowerBI.scss";
import business from "../../../services/business.js";
import InputForm from "../../Form/InputForm.js";
import config from "../../../config/config.js";
import tools from "../../../lib/tools.js";

const infoIcon = (
    <i className="ml-5 icon icon-question i-15 cursor-help" title='Dados disponíveis a partir de Março de 2026' />
);

export default function Enfermeira() {
    const typeProcess = [
        {
            id: 0,
            nome: "Todos"
        },
        {
            id: 1,
            nome: "Segunda opinião"
        },
        {
            id: 2,
            nome: "Consenso pré"
        },
        {
            id: 3,
            nome: "Junta médica ou odontológica"
        }
    ];

    const [filtros, setFiltros] = useState({
        uf: '',
        id_tipo_processo: '',
        id_operadora: '',
        id_especialidade: '',
        id_area_atuacao: '',
        competencia_inicio: '',
        competencia_fim: '',
        inicio_processo_inicio: '',
        inicio_processo_fim: '',
        data_conclusao_inicio: '',
        data_conclusao_fim: ''
    });

    const [filtro, setFiltro] = useState(false);

    const limparFiltros = async () => {
        setFiltros({});
        setFiltros(false);
        await getSearch(true, false);
    }

    const searchOperadora = async (e) => {
        e.preventDefault();
        return await business.getOperadora(e.target.value);
    }

    const searchEspecialidade = async (e) => {
        e.preventDefault();
        return await business.getEspecialidade(e.target.value);
    };

    const searchAreaAtuacao = async (e) => {
        e.preventDefault();
        return await business.getAreaAtuacao(e.target.value, 12, 1, filtros?.id_especialidade);
    };

    const setModel = async (name, value) => {
        await setFiltros(prev => ({ ...prev, [name]: value }));
    };

    const buildCompetenciaFilters = (currentFilters = {}) => {
        const preparedFilters = { ...currentFilters };

        if (preparedFilters.competencia_inicio) {
            preparedFilters.data_inicio_ciclo = `${preparedFilters.competencia_inicio}-01`;
        }

        if (preparedFilters.competencia_fim) {
            const [ano, mes] = preparedFilters.competencia_fim.split("-");

            if (ano && mes) {
                const ultimoDiaMes = new Date(Number(ano), Number(mes), 0).getDate();
                preparedFilters.data_fim_ciclo = `${ano}-${mes}-${String(ultimoDiaMes).padStart(2, "0")}`;
            }
        }

        delete preparedFilters.competencia_inicio;
        delete preparedFilters.competencia_fim;

        return preparedFilters;
    };

    const [listagemEnfermeira, setListagemEnfermeira] = useState([]);
    const [listagemEnfermeiraValidacao, setListagemEnfermeiraValidacao] = useState([]);


    const getSearch = async (loading = true, filtrar = false) => {
        setLoading(loading);
        const filtroUsado = filtrar ? buildCompetenciaFilters(filtros) : {};
        const enfermeiras = await business.getDesempenhoOperacionalEnfermeiras(filtroUsado);

        setListagemEnfermeira(!enfermeiras ? [] : enfermeiras.desempenhoEnfermeiras);
        setListagemEnfermeiraValidacao(!enfermeiras ? [] : enfermeiras.desempenhoEnfermeirasValidacao);

        setLoading(false);
        setSearchLoading(false);
    };

    // eslint-disable-next-line 
    const [searchLoading, setSearchLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            await getSearch(true, false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <div className="flex ai-fc gap-30 w-100 mb-10 mt-20 justify-content-end">

                <button className={`btn btn-${!filtro ? `outline-` : ''}primary filtros f700-16 jc-sb me-4`} onClick={() => setFiltro(!filtro)}>
                    <span className="desktop">Filtrar </span> <i className={`icon ${!filtro ? `icon-settings-sliders ` : `icon-exit `}i-20 ml-5`} />
                </button>

            </div>
            {filtro && <div className="filtro-consulta form-container grid col-12">
                <div className="w-100">
                    <div className="grid col-12 sm-gap">
                        <InputForm
                            label="Tipo de processo"
                            required
                            type="select"
                            className="span-3"
                            name="id_tipo_processo"
                            options={typeProcess}
                            value={filtros?.id_tipo_processo}
                            model={(name, id) => {
                                const selectedProcess = typeProcess.find(process => process.id === Number(id));
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_tipo_processo: selectedProcess?.id || ''
                                }));
                            }}
                        />

                        {config.isSaastoUser() && <InputForm
                            label="Operadora"
                            type="search"
                            className="span-3"
                            placeholder="Pesquisar..."
                            onSearch={searchOperadora}
                            name="id_operadora"
                            model={(...params) => {
                                const idOperadora = params[0]?.id;
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_operadora: idOperadora
                                }));
                            }}
                        />}

                        <InputForm
                            label="Especialidade"
                            type="search"
                            className="span-3"
                            placeholder="Pesquisar..."
                            onSearch={searchEspecialidade}
                            name="id_especialidade"
                            model={(...params) => {
                                const idEspecialidade = params[0]?.id;
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_especialidade: idEspecialidade
                                }));
                            }}
                        />

                        <InputForm
                            label="Área de atuação"
                            type="search"
                            className="span-3"
                            placeholder="Pesquisar..."
                            onSearch={searchAreaAtuacao}
                            name="id_area_atuacao"
                            model={(...params) => {
                                const idAreaAtuacao = params[0]?.id;
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_area_atuacao: idAreaAtuacao
                                }));
                            }}
                        />
                    </div>
                </div>
                <div className="w-100">
                    <div className="grid col-12 sm-gap">
                        <InputForm
                            label="Data competência (Inicial)"
                            type="month"
                            className="span-1"
                            name="competencia_inicio"
                            model={setModel}
                            value={filtros.competencia_inicio}
                        />
                        <span className="text-center interval">-</span>
                        <InputForm
                            label="Data competência (Final)"
                            type="month"
                            className="span-1"
                            name="competencia_fim"
                            model={setModel}
                            value={filtros.competencia_fim}
                        />
                        <InputForm className="span-1" label="Data de início (Inicial)" type="date" id="inicio_processo_inicio" name="inicio_processo_inicio" model={setModel} value={filtros.inicio_processo_inicio} />
                        <span className="text-center interval">-</span>
                        <InputForm className="span-1" label="Data de início (Final)" type="date" id="inicio_processo_fim" name="inicio_processo_fim" model={setModel} value={filtros.inicio_processo_fim} />
                        <InputForm
                            label="Data de conclusão (Inicial)"
                            type="date"
                            className="span-1"
                            id="data_conclusao_inicio"
                            name="data_conclusao_inicio"
                            model={setModel}
                            value={filtros.data_conclusao_inicio}
                        />
                        <span className="text-center interval">-</span>
                        <InputForm
                            className="span-1"
                            label="Data de conclusão (Final)"
                            type="date"
                            id="data_conclusao_fim"
                            name="data_conclusao_fim"
                            model={setModel}
                            value={filtros.data_conclusao_fim}
                        />
                        <button className="btn btn-primary f700-16 button-filtrar" onClick={() => {
                            getSearch(1, true);
                        }}>
                            Aplicar filtros
                        </button>
                        <span className="pointer float-right ml-10 mt-30" onClick={limparFiltros}>
                            <i className="icon icon-trash watermelon i-25" title="Limpar filtros" />
                        </span>
                    </div>
                </div>
            </div>}
            {
                loading ? (
                    <div className="loader loader-default is-active" />
                ) : (
                    <div>
                        <div className="relatorio-operacional-bloco mb-40 mt-40">
                            <div className="relatorio-operacional-card border-bi">
                                <div className="relatorio-operacional-card__title text-center">
                                    Consenso Pré {infoIcon}
                                </div>

                                {!listagemEnfermeira || !listagemEnfermeira.length ? (
                                    <p className="text-center p-20">Não há processos.</p>
                                ) : (
                                    <div className="relatorio-operacional-tabela relatorio-operacional-tabela--simple">
                                        <div
                                            className="relatorio-operacional-simple-grid relatorio-operacional-simple-grid--header"
                                            style={{ gridTemplateColumns: "2fr 1fr 1fr" }}
                                        >
                                            <div className="relatorio-operacional-cell relatorio-operacional-cell--name">Nome</div>
                                            <div className="relatorio-operacional-cell">Consenso andamento</div>
                                            <div className="relatorio-operacional-cell">Consenso competência</div>
                                        </div>

                                        {listagemEnfermeira.map((item, index) => (
                                            <div
                                                key={`consenso-${index}`}
                                                className="relatorio-operacional-simple-grid relatorio-operacional-row"
                                                style={{ gridTemplateColumns: "2fr 1fr 1fr" }}
                                            >
                                                <div className="relatorio-operacional-cell relatorio-operacional-cell--name">
                                                    {item.nome_enfermeira || "Sem enfermeira"}
                                                </div>
                                                <div className="relatorio-operacional-cell">
                                                    {tools.defaultData(item.cp_andamento)}
                                                </div>
                                                <div className="relatorio-operacional-cell">
                                                    {tools.defaultData(item.cp_recebidos_mes)}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="relatorio-operacional-bloco mb-40 mt-40">
                            <div className="relatorio-operacional-card border-bi">
                                <div className="relatorio-operacional-card__title text-center">
                                    JMO - Abertura {infoIcon}
                                </div>

                                {!listagemEnfermeira || !listagemEnfermeira.length ? (
                                    <p className="text-center p-20">Não há processos.</p>
                                ) : (
                                    <div className="relatorio-operacional-tabela relatorio-operacional-tabela--simple">
                                        <div
                                            className="relatorio-operacional-simple-grid relatorio-operacional-simple-grid--header"
                                            style={{ gridTemplateColumns: "2fr 1fr 1fr" }}
                                        >
                                            <div className="relatorio-operacional-cell relatorio-operacional-cell--name">Nome</div>
                                            <div className="relatorio-operacional-cell">JMO dia</div>
                                            <div className="relatorio-operacional-cell">Total competência</div>
                                        </div>

                                        {listagemEnfermeira.map((item, index) => (
                                            <div
                                                key={`jmo-abertura-${index}`}
                                                className="relatorio-operacional-simple-grid relatorio-operacional-row"
                                                style={{ gridTemplateColumns: "2fr 1fr 1fr" }}
                                            >
                                                <div className="relatorio-operacional-cell relatorio-operacional-cell--name">
                                                    {item.nome_enfermeira || "Sem enfermeira"}
                                                </div>
                                                <div className="relatorio-operacional-cell">
                                                    {tools.defaultData(item.jmo_recebidos_hoje)}
                                                </div>
                                                <div className="relatorio-operacional-cell">
                                                    {tools.defaultData(item.jmo_recebidos_mes)}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="relatorio-operacional-bloco mb-40 mt-40">
                            <div className="relatorio-operacional-card border-bi">
                                <div className="relatorio-operacional-card__title text-center">
                                    Validação SO e JMO {infoIcon}
                                </div>

                                {!listagemEnfermeiraValidacao || !listagemEnfermeiraValidacao.length ? (
                                    <p className="text-center p-20">Não há processos.</p>
                                ) : (
                                    <div className="relatorio-operacional-tabela relatorio-operacional-tabela--simple">
                                        <div
                                            className="relatorio-operacional-simple-grid relatorio-operacional-simple-grid--header"
                                            style={{ gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr 1fr" }}
                                        >
                                            <div className="relatorio-operacional-cell relatorio-operacional-cell--name">Nome</div>
                                            <div className="relatorio-operacional-cell">SO dia</div>
                                            <div className="relatorio-operacional-cell">JMO dia</div>
                                            <div className="relatorio-operacional-cell">Total dia</div>
                                            <div className="relatorio-operacional-cell">SO competência</div>
                                            <div className="relatorio-operacional-cell">JMO competência</div>
                                            <div className="relatorio-operacional-cell">Total competência</div>
                                        </div>

                                        {listagemEnfermeiraValidacao.map((item, index) => (
                                            <div
                                                key={`validacao-${index}`}
                                                className="relatorio-operacional-simple-grid relatorio-operacional-row"
                                                style={{ gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr 1fr" }}
                                            >
                                                <div className="relatorio-operacional-cell relatorio-operacional-cell--name">
                                                    {item.nome_enfermeira || "Sem enfermeira"}
                                                </div>
                                                <div className="relatorio-operacional-cell">
                                                    {tools.defaultData(item.so_recebidos_hoje)}
                                                </div>
                                                <div className="relatorio-operacional-cell">
                                                    {tools.defaultData(item.jmo_recebidos_hoje)}
                                                </div>
                                                <div className="relatorio-operacional-cell">
                                                    {tools.defaultData(item.total_recebidos_hoje)}
                                                </div>
                                                <div className="relatorio-operacional-cell">
                                                    {tools.defaultData(item.total_so_competencia)}
                                                </div>
                                                <div className="relatorio-operacional-cell">
                                                    {tools.defaultData(item.total_jmo_competencia)}
                                                </div>
                                                <div className="relatorio-operacional-cell">
                                                    {tools.defaultData(item.total_competencia)}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                )
            }
        </>
    );
}
